import swal from 'sweetalert2'

import { Button } from '@domain-group/suit-theme'

import { generateApplicationUrl } from '@domain-group/javascript-utils'

import useCampaign from '@hooks/useCampaign'

import type { UseCampaignPayload } from '@hooks/useCampaign'

import type { ModalCallbacks } from '@modals/SelectSMSRecipientModal'

import type { CampaignModel, UserModel } from '@models/types'

import { UseSelectSMSRecipientModalPayload } from '../../hooks/useSelectSMSRecipientModal'

type ShareLinkParams = {
  activityKey?: string,
  campaign: CampaignModel,
  closeModal: ModalCallbacks['closeModal'],
  linkAnchor: string,
  message: string,
  mobileFn: UseCampaignPayload['callbacks']['shareMobileLink'],
  selectedUsers: UserModel[],
  shareMobileLink: ModalCallbacks['shareMobileLink'],
}

const confirmShareLink = (params: ShareLinkParams) => {
  const {
    activityKey, campaign, closeModal, linkAnchor, mobileFn, shareMobileLink, message, selectedUsers,
  } = params

  // @ts-expect-error TS2339
  const { applicationUrl } = generateApplicationUrl({
    applicationKey: 'realhub',
    // @ts-expect-error TS2322
    environment: process.env.REACT_APP_APPLICATION_ENV,
  })

  const recipients = selectedUsers.map(user => ({
    // @ts-expect-error TS2339
    is_custom: user.is_custom || false,
    mobile: user.mobile_number,
    user_id: user.id,
  }))

  const mobileParams = {
    activity_key: activityKey,
    message,
    recipients,
    redirect_url: `${applicationUrl}/#/campaigns/${campaign.id}/edit/${linkAnchor}`,
  }

  const shareMobileLinkPayload = {
    callbacks: {
      action: mobileFn,
      afterAction: closeModal,
    },
    entityParams: mobileParams,
    toastText: 'SMS Sent',
  }

  swal.fire({
    confirmButtonColor: '#43ac6a',
    confirmButtonText: 'Yes, send it.',
    icon: 'success',
    reverseButtons: true,
    showCancelButton: true,
    text: 'Are you sure? This campaign share link will be sent via SMS to the selected recipients.',
    title: 'Share Link?',
  }).then(({ value }) => {
    if (value){
      // @ts-expect-error TS2345
      shareMobileLink(shareMobileLinkPayload)
    }
  })
}

interface ShareButtonProps {
  activityKey?: string,
  callbacks: ModalCallbacks,
  campaign: CampaignModel,
  hookPayload: UseSelectSMSRecipientModalPayload,
  linkAnchor: string,
}

const ShareButton = (props: ShareButtonProps) => {
  const {
    activityKey, callbacks, campaign, hookPayload, linkAnchor,
  } = props
  const { closeModal, shareMobileLink } = callbacks

  const {
    hasSelectedUsers,
    message,
    selectedUsers,
  } = hookPayload

  const {
    callbacks: {
      shareMobileLink: mobileFn,
    },
    creating,
  } = useCampaign(campaign)

  return (
    <Button
      buttonStyle="primaryCreate"
      disabled={!hasSelectedUsers}
      loading={creating}
      onClick={() => confirmShareLink({
        activityKey, campaign, closeModal, linkAnchor, mobileFn, shareMobileLink, message, selectedUsers,
      })}
      size="large"
    >
      {hasSelectedUsers ? 'Send Message' : 'Add Recipient'}
    </Button>
  )
}

export default ShareButton
